export class Contacto {
    codigo: number;
    nombre1: string;
    nombre2: string;
    email: string;
    telefono: string;
}